import {Alert} from '@wandb/weave/components/Alert';
import {CreateSecretFormContent} from '@wandb/weave/components/Secrets';
import React, {useContext} from 'react';
import {toast} from 'react-toastify';

import {useUpsertTeamSecretMutation} from '../../../generated/graphql';
import {extractErrorMessageFromApolloError} from '../../../util/errors';
import {JobDrawerSecretsContext} from './JobDrawerSecretsContext';

export const JobDrawerSecretsSubview = ({
  entityName,
  onClose,
}: {
  entityName: string;
  onClose?: () => void;
}) => {
  const {refetchSecrets, secretsData} = useContext(JobDrawerSecretsContext);

  const [upsertTeamSecret, {loading: isSaving}] = useUpsertTeamSecretMutation();

  const handleSave = async (input: {
    secretName: string;
    secretValue: string;
  }) => {
    try {
      await upsertTeamSecret({
        variables: {
          entityName,
          secretName: input.secretName,
          secretValue: input.secretValue,
        },
      });
      toast.success(`Added secret ${input.secretName}`);
      refetchSecrets();
      onClose?.();
    } catch (err) {
      const errMsg = extractErrorMessageFromApolloError(err);
      console.error(errMsg);
      toast.error(`Problem adding secret ${input.secretName}: ${errMsg}`);
    }
  };

  return (
    <CreateSecretFormContent
      existingSecretNames={secretsData.map(secret => secret.name)}
      isSaving={isSaving}
      onSave={handleSave}
      onCancel={() => onClose?.()}
      saveLabel="Add secret"
      banner={
        <Alert severity="info">
          This secret will be created for <strong>{entityName}</strong>, owner
          of the destination project for your launch. Team secrets can be
          managed in team settings by team admins.
        </Alert>
      }
    />
  );
};
